import { StarsButton as Button } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import type { Dispatch, RootState } from '@swf/core/store';
import { useHomeGamesWidget } from '@swf/poker';

import { HGOnboarding, ModalRoutes } from '../../../../types/common';

import { TXTCLI_Create_Tournament } from './CreateTournamentButton.messages.json';
import styles from './CreateTournamentButton.scss';

const CreateTournamentButton = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const { widgetSelect, widgetDispatch, widgetId } = useHomeGamesWidget();
  const { modal } = useDispatch<Dispatch>();
  const isTournsActive = useSelector(widgetSelect.isTournsActive);
  const newClubCreateGameOnboardingCompleted = useSelector((rootState: RootState) =>
    widgetSelect.localStorageItem(rootState, `onboarding[${HGOnboarding.NewClubCreateGame}]`)
  );

  const handleClick = () => {
    if (!newClubCreateGameOnboardingCompleted) {
      widgetDispatch.setLocalStorageItem({
        onboarding: { [HGOnboarding.NewClubCreateGame]: true }
      });
    }
    modal.enqueue({
      path: ModalRoutes.createTournament,
      locationState: { clubId, widgetId, widgetDispatch, widgetSelect }
    });
  };

  return (
    <Button
      className={styles.button}
      disabled={isTournsActive === false}
      translation={TXTCLI_Create_Tournament}
      onClick={handleClick}
    />
  );
};

export default CreateTournamentButton;
